import { FC, ReactNode, useState } from 'react'
import styled from 'styled-components'
import { Dialog } from './Dialog'
import { GlobalNotification } from './GlobalNotification'
import { Header } from './Header'

type LayoutProps = {
  children: ReactNode
}

export const Layout: FC<LayoutProps> = (props) => {
  const { children } = props
  const [isShowDialog, setIsShowDialog] = useState(false)

  return (
    <>
      <Header onClickReloadButton={() => setIsShowDialog(true)} />
      <StyledMain>{children}</StyledMain>

      <Dialog
        title="申請をはじめからやり直しますか？"
        isShow={isShowDialog}
        onClose={() => setIsShowDialog(false)}
        submitButtonTitle="やり直す"
        onSubmit={() => {
          location.href = '/'
        }}
      >
        これまでのすべての回答がクリアされ、
        <br />
        最初から再開されます。
      </Dialog>
      <GlobalNotification />
    </>
  )
}

const StyledMain = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgb(255, 255, 255);
  max-width: 1024px;
  min-height: 100%;
  margin: 0px auto;
  padding-top: 60px;
  overflow: hidden;
`
